module.exports = __webpack_public_path__ + "static/media/report_master-ioc.1a55c4a2.png";